import {
  useMediaDevices,
  useMicrophoneDeviceId,
  useScribeStore,
  useStep,
} from "../stores/scribe";
import useEffectOnce from "./useEffectOnce";

export interface UseAudioInputDeviceSelectResult {
  devices: MediaDeviceInfo[];
  selectedDeviceId: string | null;
  selectDevice: (deviceId: string | null) => void;
}

export function useAudioInputDeviceSelect(): UseAudioInputDeviceSelectResult {
  const [, setStep] = useStep();
  const [selectedDeviceId, setMicrophoneDeviceId] = useMicrophoneDeviceId();
  const [mediaDevices, getMediaDevices] = useMediaDevices();

  useEffectOnce(() => {
    const getInitialMicrophoneDeviceId = async (): Promise<void> => {
      try {
        const devices = await getMediaDevices();

        if (!devices.length) return;

        const current = useScribeStore.getState().media.microphoneDeviceId;
        const found = current && devices.some((d) => d.deviceId === current);

        if (!found) setMicrophoneDeviceId(devices[0].deviceId);
      } catch {
        setStep("errorMicrophoneInitial");
      }
    };

    getInitialMicrophoneDeviceId();
  });

  return {
    devices: mediaDevices ?? [],
    selectedDeviceId,
    selectDevice: setMicrophoneDeviceId,
  };
}
